<template>
  <div class="bg-white py-4">
    <div class="container">
      <h1 class="text-uppercase fw-bold">What we do?</h1>
      <article>
        <p class="fs-5">
          We allow TENS OF MILLIONS of car customers TO FIND <br>
          affordable cars in an efficient and EASY WAY
        </p>

        <div class="invest-comparation">
          <div class="invest-comparation__step">
            <div class="invest-comparation__title mb-3">
              <span>1. Search</span>
            </div>
            <div
              class="invest-comparation__circle rounded-3 border shadow-lg"
              :style="`background-image: url(${images.steps[0]})`"
            ></div>
          </div>
          <div class="invest-comparation__step">
            <div class="invest-comparation__title mb-3">
              <span>2. Review</span>
            </div>
            <div
              class="invest-comparation__circle rounded-3 border shadow-lg"
              :style="`background-image: url(${images.steps[1]})`"
            ></div>
          </div>
          <div class="invest-comparation__step">
            <div class="invest-comparation__title mb-3">
              <span>3. Direct to seller VDP</span>
            </div>
            <div
              class="invest-comparation__circle rounded-3 border shadow-lg"
              :style="`background-image: url(${images.steps[2]})`"
            ></div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>


<script>

import step1 from "@/images/invest/step1.png";
import step2 from "@/images/invest/step2.png";
import step3 from "@/images/invest/step3.png";

export default {
  data() {
    return {
      images: {
        steps: [step1, step2, step3],
      }
    }
  }
}
</script>